module.exports = __webpack_public_path__ + "img/Intro.34be1f80.gif";